<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]" v-if="$aclInterfaceValidator('weeboxcore.schedule.stats-employees')">

        <header class="widget-header">
            <h2 class="widget-title">{{ title }}</h2>
            <h3 class="widget-title-period">
                <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
            </h3>

            <div class="widget-actions-container">
            <div>
              <button-action  type="export"/>
            </div>
                <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
            </div>

            <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
                <span>Filtrer par date</span>
                <div class="date-filters">
                    <form-datetime label="du" v-model="dateFilter.start_at" :hide-time="false" time="00:00:00"></form-datetime>
                    <form-datetime label="au" v-model="dateFilter.end_at" :hide-time="false" time="23:59:59"></form-datetime>
                </div>
            </div>

        </header>

        <div class="widget-preloader">
            <div class="pre-loader">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3"></div>
                <div class="box4"></div>
                <div class="box5"></div>
            </div>
        </div>

        <div class="widget-content">

            <div style="display: flex;font-size: 10px;font-weight:400;padding: 5px 0;align-items: center;width: 100%;border-bottom:1px solid #eee;text-transform: uppercase">
                <div style="flex: 1;">Employé</div>
                <div style="width: 120px;text-align: right;">Planifiés</div>
                <div style="width: 120px;text-align: right;">Facturés</div>
            </div>

            <div v-if="data && data.length >= 1" v-for="item in data" style="display: flex;font-size: 12px;padding: 5px 0;align-items: center;width: 100%;border-bottom:1px solid #eee;height: 40px;">
                <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    <strong style="font-weight: 800;font-size: 1.1em; margin-bottom: 0.3em; display: block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                        {{ item.name }}
                    </strong>
                </div>
                <div style="width: 120px;text-align: right;margin-left: auto;">
                    <strong style="font-weight:300;">{{ item.scheduled|formatNumber }} {{ currency }}</strong>
                </div>
                <div style="width: 120px;text-align: right;">
                    <strong style="font-weight:800;color:green;">{{ item.paied|formatNumber }} {{ currency }}</strong>
                </div>
            </div>

            <div v-if="data.length <= 0" style="font-size: 12px;">
                <p style="font-size: 12px;">Aucun résultat trouvé</p>
            </div>

        </div>
    </div>
</template>
<script>

    import ScheduleService from './ScheduleService.js';

    export default {
        name: 'Widget',
        props: ['title','branch','period','className'],
        data () {
            return {
                periods: [
                    {id: 'last_month', label: 'Dernier mois'},
                    {id: 'current_month', label: 'Ce mois'},
                    {id: 'custom', label: 'Personnalisé'},
                ],
                loaded: false,
                showAdvancedFilterVue: false,
                dateFilter: {
                    start_at: null,
                    end_at: null,
                },
                data: [],
                currency: null,
                branch_id: null
            }
        },
        mounted: function(){

            this.period = this.period ? this.period : this.periods[0].id
            this.branch_id = this.branch ? this.branch : null
            this.filterByPeriod(this.period);
            this.currency = this.$store.state.scope.currency_id

        },
        watch: {
            'dateFilter.start_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.end_at != ''){
                    this.filterByPeriod(this.period, this.dateFilter);
                }
            },
            'dateFilter.end_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.start_at != ''){
                    this.filterByPeriod(this.period, this.dateFilter);
                }
            }
        },
        methods: {
            exportFile: function()
            {

                let filter = true

                if(this.period == 'custom') {
                    this.showAdvancedFilterVue = true
                    this.date = JSON.stringify(this.dateFilter);
                }else{
                    this.showAdvancedFilterVue = false;
                    this.date = null;
                }

                if( filter )
                {
                    ScheduleService.export(this.period, this.date).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'export.xlsx'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    })
                }


            },
            filterByPeriod: function(period, dateFilter)
            {

                let filter = true

                if(period == 'custom') {
                    this.showAdvancedFilterVue = true
                    this.date = JSON.stringify(dateFilter);
                    filter = dateFilter ? true : false
                }else{
                    this.showAdvancedFilterVue = false;
                    this.date = null;
                }

                if( filter )
                {
                    this.loaded = false;
                    this.period = period
                    ScheduleService.getStatsByUsers( this.period, this.branch_id, this.date ).then((response) => {
                        this.data = response.data;
                        this.loaded = true;
                    }).catch((response) => {
                        console.log("error", response);
                        this.loaded = true;
                    });
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reservation/SchedulesDonePerUserWidget.vue